import { rest } from 'msw'

export default [
  /**
   * RO 演算設定
   */
  rest.get('/swc-api/nodes/:nodeId/ro/calculation-settings', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
            "id": 3,
            "node_id": 6,
            "calculation_no": 1,
            "module_name": "モジュール1",
            "calculation_type": "RO",
            "organization_code": "6",
            "organization_name": "A 社",
            "calculation_setting": {
                "input": {
                    "process": "D005512_14",
                    "judgements": [
                        {
                            "group_code": "cf_diff_pressure",
                            "item": "cf_in_pressure",
                            "field_name": "ro_filter_P001_s1",
                            "thresholds": [0.4, 0.5],
                            "judge_type": "neg"    
                        },
                        {
                            "group_code": "cf_diff_pressure",
                            "item": "cf_out_pressure",
                            "field_name": "ro_pump_P001_s1",
                            "thresholds": [0.1, 0.2],
                            "judge_type": "pos"
                        },
                        {
                            "group_code": "cf_diff_pressure",
                            "item": "cf_diff_pressure",
                            "field_name": "ro_filter_P002_s1",
                            "thresholds": [0.05, 0.1],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_in_pressure",
                            "field_name": "ro_P001_s1",
                            "thresholds": [1.4, 1.6],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_1st_out_pressure",
                            "field_name": "ro_P002_s1",
                            "thresholds": [1.3, 1.5],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_2nd_out_pressure",
                            "field_name": "ro_P003_s1",
                            "thresholds": [1.2, 1.3],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_permeated_water_pressure",
                            "field_name": "ro_P004_s1",
                            "thresholds": [0.05, 0.1],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure_loss",
                            "item": "all_pressure_loss",
                            "field_name": "ro_PD000_ex_s1",
                            "thresholds": [0.2, 0.3],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure_loss",
                            "item": "ro_1st_pressure_loss",
                            "field_name": "ro_PD001_s1",
                            "thresholds": [0.2, 0.3],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure_loss",
                            "item": "ro_2nd_pressure_loss",
                            "field_name": "ro_PD002_s1",
                            "thresholds": [0.05, 0.1],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "water_flow",
                            "item": "permeated_water_flow",
                            "field_name": "ro_F001_s1",
                            "thresholds": [40, 45],
                            "judge_type": "pos"    
                        },
                        {
                            "group_code": "water_flow",
                            "item": "concentrated_water_flow",
                            "field_name": "ro_F002_s1",
                            "thresholds": [10, 12],
                            "judge_type": "pos"    
                        },
                        {
                            "group_code": "conductivity",
                            "item": "conductivity",
                            "field_name": "ro_X001_s1",
                            "thresholds": [4, 5],
                            "judge_type": "neg"    
                        },
                        {
                            "group_code": "water_temperature",
                            "item": "water_temperature",
                            "field_name": "ro_T001_s1",
                            "thresholds": [5, 10, 27, 32],
                            "judge_type": "pattern1"    
                        },
                        {
                            "group_code": "corrected_permeated_water_flow",
                            "item": "corrected_permeated_water_flow",
                            "field_name": "ro_F001_ex_s1",
                            "thresholds": [60, 70],
                            "judge_type": "pos"    
                        }
                    ]
                },
                "output": {
                    "threshold":{
                        "bad": 1,
                        "neutral": 1
                    }
                },
                "notification": {
                    "notify_flag": true
                }
            }
        },
        {
            "id": 4,
            "node_id": 10003,
            "calculation_no": 2,
            "module_name": "モジュール2",
            "calculation_type": "RO",
            "organization_code": "6",
            "organization_name": "A 社",
            "calculation_setting": {
                "input": {
                    "process": "D005512_17",
                    "judgements": [
                        {
                            "group_code": "pressure",
                            "item": "ro_in_pressure",
                            "field_name": "ro_P001_s2",
                            "thresholds": [1.1, 1.3],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_1st_out_pressure",
                            "field_name": "ro_P002_s2",
                            "thresholds": [1.0, 1.2],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_2nd_out_pressure",
                            "field_name": "ro_P003_s2",
                            "thresholds": [0.9, 1.1],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_3rd_out_pressure",
                            "field_name": "ro_P004_s2",
                            "thresholds": [0.8, 1.0],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_permeated_water_pressure",
                            "field_name": "ro_P005_s2",
                            "thresholds": [0.1, 0.15],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure_loss",
                            "item": "all_pressure_loss",
                            "field_name": "ro_PD000_ex_s2",
                            "thresholds": [0.4, 0.5],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure_loss",
                            "item": "ro_1st_pressure_loss",
                            "field_name": "ro_PD001_s2",
                            "thresholds": [0.2, 0.3],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure_loss",
                            "item": "ro_2nd_pressure_loss",
                            "field_name": "ro_PD002_s2",
                            "thresholds": [0.2, 0.3],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure_loss",
                            "item": "ro_3rd_pressure_loss",
                            "field_name": "ro_PD003_s2",
                            "thresholds": [0.2, 0.3],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "water_flow",
                            "item": "permeated_water_flow",
                            "field_name": "ro_F001_s2",
                            "thresholds": [40, 45],
                            "judge_type": "pos"    
                        },
                        {
                            "group_code": "water_flow",
                            "item": "concentrated_water_flow",
                            "field_name": "ro_F002_s2",
                            "thresholds": [2.0, 2.5],
                            "judge_type": "pos"    
                        },
                        {
                            "group_code": "conductivity",
                            "item": "conductivity",
                            "field_name": "ro_X001_s2",
                            "thresholds": [0.75, 1.0],
                            "judge_type": "neg"    
                        },
                        {
                            "group_code": "water_temperature",
                            "item": "water_temperature",
                            "field_name": "ro_T001_s2",
                            "thresholds": [5, 7, 30, 32],
                            "judge_type": "pattern1"    
                        },
                        {
                            "group_code": "corrected_permeated_water_flow",
                            "item": "corrected_permeated_water_flow",
                            "field_name": "ro_F001_ex_s2",
                            "thresholds": [70, 85],
                            "judge_type": "pos"    
                        }
                    ]
                },
                "output": {
                    "threshold":{
                        "bad": 1,
                        "neutral": 1
                    }
                },
                "notification": {
                    "notify_flag": true
                }
            }
        },
        {
            "node_id": 101,
            "calculation_no": 1,
            "module_name": "モジュール1",
            "calculation_type": "RO",
            "organization_code": "6",
            "organization_name": "A 社",
            "calculation_setting": {
                "input": {
                    "process": "D005512_14",
                    "judgements": [
                        {
                            "group_code": "cf_diff_pressure",
                            "item": "cf_in_pressure",
                            "field_name": "ro_filter_P001_s1",
                            "thresholds": [0.4, 0.5],
                            "judge_type": "neg"    
                        },
                        {
                            "group_code": "cf_diff_pressure",
                            "item": "cf_out_pressure",
                            "field_name": "ro_pump_P001_s1",
                            "thresholds": [0.1, 0.2],
                            "judge_type": "pos"
                        },
                        {
                            "group_code": "cf_diff_pressure",
                            "item": "cf_diff_pressure",
                            "field_name": "ro_filter_P002_s1",
                            "thresholds": [0.05, 0.1],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_in_pressure",
                            "field_name": "ro_P001_s1",
                            "thresholds": [1.4, 1.6],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_1st_out_pressure",
                            "field_name": "ro_P002_s1",
                            "thresholds": [1.3, 1.5],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_2nd_out_pressure",
                            "field_name": "ro_P003_s1",
                            "thresholds": [1.2, 1.3],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure",
                            "item": "ro_permeated_water_pressure",
                            "field_name": "ro_P004_s1",
                            "thresholds": [0.05, 0.1],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure_loss",
                            "item": "all_pressure_loss",
                            "field_name": "ro_PD000_ex_s1",
                            "thresholds": [0.2, 0.3],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure_loss",
                            "item": "ro_1st_pressure_loss",
                            "field_name": "ro_PD001_s1",
                            "thresholds": [0.2, 0.3],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "pressure_loss",
                            "item": "ro_2nd_pressure_loss",
                            "field_name": "ro_PD002_s1",
                            "thresholds": [0.05, 0.1],
                            "judge_type": "neg"
                        },
                        {
                            "group_code": "water_flow",
                            "item": "permeated_water_flow",
                            "field_name": "ro_F001_s1",
                            "thresholds": [40, 45],
                            "judge_type": "pos"    
                        },
                        {
                            "group_code": "water_flow",
                            "item": "concentrated_water_flow",
                            "field_name": "ro_F002_s1",
                            "thresholds": [10, 12],
                            "judge_type": "pos"    
                        },
                        {
                            "group_code": "conductivity",
                            "item": "conductivity",
                            "field_name": "ro_X001_s1",
                            "thresholds": [4, 5],
                            "judge_type": "neg"    
                        },
                        {
                            "group_code": "water_temperature",
                            "item": "water_temperature",
                            "field_name": "ro_T001_s1",
                            "thresholds": [5, 10, 27, 32],
                            "judge_type": "pattern1"    
                        },
                        {
                            "group_code": "corrected_permeated_water_flow",
                            "item": "corrected_permeated_water_flow",
                            "field_name": "ro_F001_ex_s1",
                            "thresholds": [60, 70],
                            "judge_type": "pos"    
                        }
                    ]
                },
                "output": {
                    "threshold":{
                        "bad": 1,
                        "neutral": 1
                    }
                },
                "notification": {
                    "notify_flag": true
                }
            }
        }
      ]),
    )
  }),
  /**
   * RO 演算設定新規登録
   */
   rest.post('/swc-api/nodes/:nodeId/ro/calculation-settings', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * RO 演算設定更新
   */
  rest.put('/swc-api/nodes/:nodeId/ro/calculation-settings/:calculationSettingsId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * RO 演算設定削除
   */
  rest.delete('/swc-api/nodes/:nodeId/ro/calculation-settings/:calculationSettingsId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
]
